<template>
  <div class="bc__ui__leaderboard">
    <ol>
        <li v-for="(item, i) in this.list" :key="i">
            <div class="heading" :class="{'heading--img': (opt.with_img == true)}">
                <p>{{item.name}}</p>
                <data :value="item.value">{{item.value}}</data>
                <img :src="item.img">
            </div>
            <div class="line">
                <span :style="{'width': (item.perc * 100) + '%'}" :class="['bg--' + item.bg, {'blocked--width': !flagMounted}]"></span>
            </div>
        </li>
    </ol>
  </div>
</template>

<style lang="scss" scoped >

</style>


<script>
    export default {

        props: [
            'list', 'opt' 
        ],

        data() {
            return {
                flagMounted: false
            }
        },

        methods: {

        },

        mounted() {
            this.flagMounted = true;
        }
    }

</script>